<template>
  <div v-if="entry.postscan">
    <button class="btn btn-primary" disabled>
      <i class="fas fa-print"></i> Postscan
    </button>
  </div>
  <div v-else></div>
</template>

<script>
import { defineComponent } from "vue";


export default defineComponent({
  props: {
    entry: Object
  },
  methods: {
  },
});
</script>
